import styled from 'styled-components';

import Button from '@components/Button';

export const CardWrapper = styled.div`
  border-radius: 12px;
  box-shadow: 0 2px 8px #eee;
  min-width: 220px;
  display: flex;
  flex-direction: column;
  &:hover {
    .preferredHotelCard__image {
      -webkit-transition: all 0.5s ease-out;
      transition: all 0.5s ease-out;
      transform: scale(1.1);
    }
  }
  .preferredHotelCard__image {
    -webkit-transition: all 0.5s ease-out;
    transition: all 0.5s ease-out;
  }
`;

export const HotelImageWrapper = styled.div`
  width: 100%;
  height: 400px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HotelInfoOverlay = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 16px 12px 12px 12px;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 60%,
    rgba(0, 0, 0, 0.55) 100%
  );
  color: #fff;
  z-index: 2;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`;

export const HotelName = styled.h2`
  font-weight: 700;
  font-size: 22px;
  color: #fff;
  margin: 0 0 4px 0;
  line-height: 1.2;
  letter-spacing: 0.5px;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.7), 0 0 2px rgba(0, 0, 0, 0.9);
`;

export const PriceWrapper = styled.div``;

export const FromText = styled.div`
  font-size: 14px;
  color: white;
  margin-top: 4px;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.7), 0 0 2px rgba(0, 0, 0, 0.9);
`;

export const TabWrapper = styled.div`
  margin-top: 24px;
  margin-bottom: 24px;
  display: flex;
  gap: 8px;

  overflow-x: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
  &::-webkit-scrollbar {
    display: none;
  }
  align-items: center;
  justify-content: space-between;

  & > div {
    @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
      width: 100%;
      display: block;
      overflow-x: auto;
      white-space: nowrap;
      gap: 8px;
    }
  }

  & > a {
    display: block;

    ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
      display: none;
    }
  }
`;

export const TabButton = styled(Button)<{ active: boolean }>`
  &&& {
    box-shadow: none !important;
    flex: 0 0 auto;
    padding: 8px 16px;
    margin-top: 8px;
    border-radius: 20px;
    background: ${(props) =>
      props.active ? props.theme.palette.primaryBrand : 'white'};
    color: ${(props) => (props.active ? 'white' : '#000')};
    border: 1px solid #ddd;
    cursor: pointer;
    outline: none;
    user-select: none;
    transition: background-color 0.3s ease, color 0.3s ease,
      border-color 0.3s ease;

    &:hover {
      background: ${(props) =>
        props.active
          ? props.theme.palette.primaryBrandDark
          : props.theme.palette.whiteSmoke};
    }

    &:focus {
      outline: none;
    }
    @media (max-width: 900px) {
      margin-top: 0;
    }
  }
  margin-right: 8px;
`;

export const HotelOrderBadge = styled.div`
  position: absolute;
  top: 12px;
  left: 12px;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
`;

export const Line = styled.div`
  width: 36px;
  height: 6px;
  margin: 15px 0 15px 0;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.palette.red};
`;
